export enum PlayerType {
  UNTITLED = 'untitled',
  TITLED = 'titled',
  COACH = 'coach',
  STREAMER = 'streamer',
  GAMBIT_MASTER = 'gambitmaster',
}

export enum PlayerTitle {
  GM = 'GM',
  FM = 'FM',
  IM = 'IM',
  CM = 'CM',
  WGM = 'WGM',
  WFM = 'WFM',
  WIM = 'WIM',
  WCM = 'WCM',
}

export enum PlayerStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
  PLAYING = 'playing',
}

export enum RatingDisplayMode {
  NUMBER = 'number',
  DOTS = 'dots',
}

/** Numeric, matching the API's `LoginProvider` enum and the `users.login_provider` integer column. */
export enum SignUpProvider {
  GOOGLE = 0,
  EMAIL = 1,
  LICHESS = 2,
  APPLE = 3,
}

export enum UsernameRejection {
  FORMAT = 'format',
  NOT_ALLOWED = 'not_allowed',
  TAKEN = 'taken',
}

export enum UsernameIssue {
  FORMAT = 'format',
  RESERVED = 'reserved',
  NOT_ALLOWED = 'not_allowed',
}
